import { render } from "./HiTags.vue?vue&type=template&id=6227d84e"
import script from "./HiTags.vue?vue&type=script&lang=js"
export * from "./HiTags.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__